var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUser = function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 25"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#827127"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5 6.5a6 6 0 1 1-12 0 6 6 0 0 1 12 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.5 24.5c0-6.627 5.373-12 12-12 6.628 0 12 5.373 12 12"
  }))));
};
export default SvgUser;